import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  ReferenceDot,
} from "recharts";
import { ListDivider } from "../../ui/ListStyles";
import { COLORS } from "../../ui/Theme";
import { Typography } from "@mui/material";

const CustomTooltip = ({ active, payload, latestPriceChange, unit }) => {
  if (active && payload && payload.length) {
    const { y, x } = payload[0].payload;

    const backgroundColor =
      latestPriceChange < 0 ? COLORS.SOFTRED : COLORS.SOFTGREEN;

    return (
      <div
        style={{
          color: latestPriceChange < 0 ? COLORS.RED : COLORS.GREEN,
          display: "flex",
          justifyContent: "center",
          flexDirection: "column",
          gap: "5px",
          textAlign: "center",
          fontWeight: 900,
          backgroundColor,
          borderRadius: "4px",
          padding: "4px 8px",
          boxShadow: "0 16px 32px -4px #0C0C0D1A",
        }}
      >
        <Typography
          sx={{ fontSize: "10px", fontWeight: 900 }}
        >{`${y} ${unit}`}</Typography>
        <ListDivider flexItem />
        <Typography
          sx={{ color: COLORS.BLACK, fontSize: "10px", fontWeight: 900 }}
        >
          {x}
        </Typography>
      </div>
    );
  }
  return null;
};

const MarketWatchTopGainersChart = ({ data, latestPriceChange, unit }) => {
  const borderColor = latestPriceChange < 0 ? "#FF5252" : "#4CAF50";

  const gradientId = latestPriceChange < 0 ? "redGradient" : "greenGradient";

  const latestData = data[data.length - 1];

  return (
    <div
      style={{
        backgroundColor: COLORS.SOFTGRAY,
        borderRadius: "10px",
        padding: 0,
        margin: 0,
        width: "100%",
        height: "150px",
        overflow: "hidden",
      }}
    >
      <ResponsiveContainer width="100%" height="100%">
        <AreaChart
          data={data}
          margin={{ top: 10, right: 10, left: 10, bottom: 10 }}
        >
          <XAxis
            dataKey="x"
            tick={false}
            axisLine={false}
            height={0}
            padding={{ left: 0, right: 0 }}
          />
          <YAxis
            tick={false}
            axisLine={false}
            padding={{ top: 0, bottom: 0 }}
            width={0}
          />
          <Tooltip
          cursor={{ fill: COLORS.SOFTGRAY }}
            content={
              <CustomTooltip
                latestPriceChange={latestPriceChange}
                unit={unit}
              />
            }
          />
          <defs>
            <linearGradient id="greenGradient" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="#C8E6C9" stopOpacity={1} />
              <stop
                offset="100%"
                stopColor="rgba(200, 230, 201, 0)"
                stopOpacity={1}
              />
            </linearGradient>
            <linearGradient id="redGradient" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="#FFCDD2" stopOpacity={1} />
              <stop
                offset="100%"
                stopColor="rgba(255, 205, 210, 0)"
                stopOpacity={1}
              />
            </linearGradient>
          </defs>
          <Area
            type="monotone"
            dataKey="y"
            stroke={borderColor}
            strokeWidth={2}
            fill={`url(#${gradientId})`}
            fillOpacity={1}
            isAnimationActive={false}
          />

          <ReferenceDot
            x={latestData.x}
            y={latestData.y}
            r={5}
            fill={borderColor}
            stroke="#FFFFFF"
            strokeWidth={1}
          />

          <text
            x="95%"
            y="90%"
            textAnchor="start"
            fill={COLORS.BLACK}
            fontSize={10}
            fontWeight={700}
          >
            {`${latestData.y} ${unit}`}
          </text>
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
};

export default MarketWatchTopGainersChart;
